import { IncompletionModal } from 'components/SurveyElements';
import React from 'react';
import ReactDOM from 'react-dom';

const UserConfirmation = (message: string, callback: any) => {
  const container = document.createElement('div');
  container.setAttribute('custom-confirmation-navigation', '');
  document.body.appendChild(container);

  const closeModal = (callbackState: boolean) => {
    ReactDOM.unmountComponentAtNode(container);
    document.body.removeChild(container);
    callback(callbackState);
  };

  ReactDOM.render(
    <IncompletionModal
      isOpen={true}
      message={message}
      onContinue={() => closeModal(false)}
      onExit={() => closeModal(true)}
    />,
    container
  );
};
export default UserConfirmation;
